import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spinner } from '../UI';
import { getGuardianStudents, clearGuardianStudentSchedule } from 'actions/guardians';
import { getMenuItems } from 'actions/menu';
import { getGuardianStudentPlans, clearGuardianStudentPlans } from 'actions/planning';
import { getGuardianStudentAssignments, clearGuardianStudentAssignments } from 'actions/assignments';
import { getStudentEducationGroups, clearGuardianStudentGroups } from 'actions/sections';
import { clearGuardianStudentPosts } from 'actions/posts';
import { clearGuardianStudentDocumentations } from 'actions/documents';
import { clearAssessments } from 'actions/assessments';
import { clearStudentAdjustments } from 'actions/additional_adjustments';
import { clearMeetings } from 'actions/meetings';
import { clearStudyPlans } from 'actions/studyplans';
var SchoolSwitch = /*#__PURE__*/function (_Component) {
  function SchoolSwitch() {
    _classCallCheck(this, SchoolSwitch);
    return _callSuper(this, SchoolSwitch, arguments);
  }
  _inherits(SchoolSwitch, _Component);
  return _createClass(SchoolSwitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.clearGuardianStudentDocumentations();
      this.props.clearGuardianStudentPosts();
      this.props.clearGuardianStudentPlans();
      this.props.clearGuardianStudentAssignments();
      this.props.clearGuardianStudentSchedule();
      this.props.clearAssessments();
      this.props.clearStudentAdjustments();
      this.props.clearMeetings();
      this.props.clearGuardianStudentGroups();
      this.props.clearStudyPlans();
      this.props.getStudentEducationGroups(this.props.activeStudent.id);
      this.props.getMenuItems(this.props.activeStudent.id);
      this.props.history.push("/");
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "app-comp-content content"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent
  };
}
export default withRouter(connect(mapStateToProps, {
  getGuardianStudents: getGuardianStudents,
  getGuardianStudentAssignments: getGuardianStudentAssignments,
  getGuardianStudentPlans: getGuardianStudentPlans,
  getStudentEducationGroups: getStudentEducationGroups,
  clearGuardianStudentGroups: clearGuardianStudentGroups,
  clearGuardianStudentDocumentations: clearGuardianStudentDocumentations,
  clearGuardianStudentPosts: clearGuardianStudentPosts,
  clearGuardianStudentPlans: clearGuardianStudentPlans,
  clearGuardianStudentAssignments: clearGuardianStudentAssignments,
  clearGuardianStudentSchedule: clearGuardianStudentSchedule,
  clearAssessments: clearAssessments,
  clearStudentAdjustments: clearStudentAdjustments,
  clearMeetings: clearMeetings,
  clearStudyPlans: clearStudyPlans,
  getMenuItems: getMenuItems
})(SchoolSwitch));